// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1U_rl","input":"styles_input__2hL2D"};